import React, { Component } from 'react'
import { get } from '../Storage';
import axios from 'axios';

var AppSettings = get();
var componentName = AppSettings.appId + 'MasterAgentBadgeComponent';

var styles = AppSettings.styles;

export default class MasterAgentBadge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: null,
            errors: [],
            showLoading: true
        }
        this.loadMandatoryInfo = this.loadMasterAgentInfo.bind(this)
    }

    componentDidMount() {
        if(AppSettings.badgemasteragent){
            this.loadMasterAgentInfo();
        }
    }

    loadMasterAgentInfo() {
        let url = AppSettings['env'].urlMasterAgentInfo;
        axios.get(url).then(({ data }) => {
            if (data.errors.length == 0) {
                this.setState({
                    showLoading: false,
                    url: data.info,
                    errors: []
                });
            } else {
                this.setState({
                    showLoading: false,
                    url: null,
                    errors: data.errors,
                });
            }
        }).catch(() => {
            this.setState({
                showLoading: false,
                data: null,
                errors: [
                    {
                        "code": 200,
                        "internalMessage": "Error catch UserBoxLoadMasterAgentInfo",
                        "moreInfo": null,
                        "userMessage": "Si è verificato un errore inaspettato"
                    }
                ]
            })
        })
    }

    render() {
        return (
            <>
                {!this.state.showLoading && this.state.errors.length == 0 && this.state.url ?
                    <div id="ub-masteragent-info">
                        {this.props.label && <p className='ub-badge-label'>Master Agent</p>}
                        <figure className='ub-badge-brand'>
                            <img src={this.state.url} alt='Master Agent' />
                        </figure>
                    </div > : null
                }
            </>
        )
    }
}


MasterAgentBadge.displayName = componentName;

MasterAgentBadge.defaultProps = {
};

MasterAgentBadge.contextTypes = {

}